import { SwipeButtonState } from '@/common/enum/swipe-button-state.enum';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DualRingLoader from '@/common/components/loading-icon/loading-icon';
import './swipe-button.scss';
import { DisplayType } from '@/common/enum/display-type.enum';
/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({})
export default class SwipeButton extends Vue {
  mouseIsDown = false;
  initialMouse = 0;
  slideMovementTotal = 0;
  mouseIsOutBrowser = false;
  state = SwipeButtonState.START;
  @Prop({ default: DisplayType.FORM }) displayType!: DisplayType;
  isIntransition = false;
  timeoutId: ReturnType<typeof setTimeout> | null = null;
  @Prop() text!: string;
  render() {
    return (
      <div
        class={this.displayType === DisplayType.FORM ? 'button-background' : 'button-background-modal'}
        ref="container"
      >
        <span class={this.displayType === DisplayType.FORM ? 'slide-text' : 'slide-text-modal'} ref="text">
          {this.text}
        </span>
        <div
          id={this.displayType === DisplayType.FORM ? 'slider' : 'slider-modal'}
          onMousedown={(e: MouseEvent) => this.handleOnDrag(e)}
          onTouchstart={(e: TouchEvent) => this.handleOnDrag(e)}
          onMousemove={(e: MouseEvent) => this.handleOnMove(e)}
          onTouchmove={(e: TouchEvent) => this.handleOnMove(e)}
          onMouseup={(e: MouseEvent) => this.handleOnDragEnd(e)}
          onTouchend={(e: TouchEvent) => this.handleOnDragEnd(e)}
          ref="slider"
          class={{ unlocked: this.state !== SwipeButtonState.START, 'cursor-pointer': true }}
          // onClick={(e: Event) => this.handleClick(e)}
        >
          {this.state === SwipeButtonState.START && (
            <i id="locker" class="material-icons cursor-pointer">
              double_arrow
            </i>
          )}
          {this.state === SwipeButtonState.PROCESSING && <DualRingLoader />}
          {this.state === SwipeButtonState.SUCCESS && (
            <i id="locker" class="material-icons">
              check_circle
            </i>
          )}
          {this.state === SwipeButtonState.ERROR && (
            <i id="locker" class="material-icons">
              error
            </i>
          )}
        </div>
      </div>
    );
  }
  handleFinished(isEmitEvent = true) {
    this.state = SwipeButtonState.PROCESSING;
    this.isIntransition = true;
    if (isEmitEvent) {
      this.$emit('finished-swipe');
    }
  }

  handleSuccess(resetState = true) {
    this.state = SwipeButtonState.SUCCESS;
    if (!resetState) {
      this.isIntransition = false;
      return;
    }
    this.isIntransition = true;
    this.timeoutId = setTimeout(() => {
      this.isIntransition = false;
      this.resetToStateToStart();
    }, 1500);
  }

  /**
   * スワイプボタンのリセットタイムアウトをクリアします。
   */
  clearSwipeBtnResetTimeout(): void {
    if (this.timeoutId && this.state !== SwipeButtonState.START) {
      clearTimeout(this.timeoutId);
    }
  }

  resetToStateToStart() {
    const slider = this.$refs.slider as HTMLDivElement;
    if (!slider) {
      return;
    }
    if (this.state === SwipeButtonState.START || this.isIntransition) return;
    this.state = SwipeButtonState.START;
    slider.style.left = '-10px';
    this.smoothOpacity(1);
  }

  handleError(resetState = true) {
    this.state = SwipeButtonState.ERROR;
    if (!resetState) {
      return;
    }
    this.isIntransition = true;
    setTimeout(() => {
      this.isIntransition = false;
      this.resetToStateToStart();
    }, 1500);
  }

  handleOnDrag(event: MouseEvent | TouchEvent) {
    if (this.state !== SwipeButtonState.START) return;
    this.mouseIsDown = true;
    document?.body?.addEventListener('mouseup', this.handleOnDragEnd);
    document?.body?.addEventListener('touchend', this.handleOnDragEnd);
    document?.body?.addEventListener('mousemove', this.handleOnMove);
    document?.body?.addEventListener('touchmove', this.handleOnMove);
    this.slideMovementTotal =
      (this.$refs.container as HTMLDivElement).clientWidth - (this.$refs.slider as HTMLDivElement).clientWidth + 10;
    this.initialMouse = (event as MouseEvent).clientX || (event as TouchEvent).touches[0].pageX;
  }

  handleOnDragEnd(event: MouseEvent | TouchEvent) {
    if (this.state !== SwipeButtonState.START) return;
    if (!this.mouseIsDown) return;
    this.mouseIsDown = false;
    document?.body?.removeEventListener('mouseup', this.handleOnDragEnd);
    document?.body?.removeEventListener('touchend', this.handleOnDragEnd);
    document?.body?.removeEventListener('mousemove', this.handleOnMove);
    document?.body?.removeEventListener('touchmove', this.handleOnMove);
    const currentMouse = (event as MouseEvent).clientX || (event as TouchEvent).changedTouches[0].pageX;
    const relativeMouse = currentMouse - this.initialMouse;
    if (this.mouseIsOutBrowser) {
      this.mouseIsOutBrowser = false;
      return;
    }
    if (relativeMouse < this.slideMovementTotal) {
      this.smoothOpacity(1);
      this.smoothResetslider();
      return;
    }
    this.handleFinished();
  }

  private smoothResetslider() {
    const slider = this.$refs.slider as HTMLDivElement;
    const animation = slider.animate(
      {
        left: [slider.style.left, '-10px']
      },
      300
    );
    animation.onfinish = () => {
      animation.cancel();
      slider.style.left = '-10px';
    };
  }

  handleOnMove(event: MouseEvent | TouchEvent) {
    if (this.state !== SwipeButtonState.START) return;
    if (!this.mouseIsDown) return;
    const slider = this.$refs.slider as HTMLDivElement;
    const currentMouse = (event as MouseEvent).clientX || (event as TouchEvent).touches[0].pageX;
    const relativeMouse = currentMouse - this.initialMouse;
    const percentToEnd = relativeMouse / this.slideMovementTotal;
    const slidePercent = 1 - percentToEnd;
    this.smoothOpacity(slidePercent);

    if (relativeMouse <= 0) {
      slider.style.left = '-10px';
      return;
    }
    if (this.mouseIsOutBrowser) {
      this.mouseIsOutBrowser = false;
      return;
    }
    if (relativeMouse >= this.slideMovementTotal + 10) {
      slider.style.left = this.slideMovementTotal + 'px';
      return;
    }
    const left = relativeMouse - 10;
    slider.style.left = left + 'px';
  }

  handleMoveOutBrowser(event: MouseEvent) {
    if (this.state !== SwipeButtonState.START) return;
    if (!this.mouseIsDown) return;
    if (
      event?.clientY <= 0 ||
      event?.clientX <= 0 ||
      event?.clientX >= window.innerWidth ||
      event?.clientY >= window.innerHeight
    ) {
      this.mouseIsOutBrowser = true;
      this.mouseIsDown = false;
      this.handleFinished();
      return;
    }
  }

  private smoothOpacity(percent: number) {
    const text = this.$refs.text as HTMLSpanElement;
    const animation = text.animate(
      {
        opacity: [text.style.opacity, percent + '']
      },
      {
        duration: 300,
        easing: 'linear',
        iterations: 1,
        fill: 'both'
      }
    );
    animation.onfinish = () => {
      text.style.opacity = percent + '';
    };
  }
  mounted() {
    document?.body?.addEventListener('mouseup', this.handleOnDragEnd);
    document?.body?.addEventListener('touchend', this.handleOnDragEnd);
    document?.body?.addEventListener('mousemove', this.handleOnMove);
    document?.body?.addEventListener('touchmove', this.handleOnMove);
    document?.body?.addEventListener('mouseleave', this.handleMoveOutBrowser);
  }

  beforeDestroy() {
    document?.body?.removeEventListener('mouseup', this.handleOnDragEnd);
    document?.body?.removeEventListener('touchend', this.handleOnDragEnd);
    document?.body?.removeEventListener('mousemove', this.handleOnMove);
    document?.body?.removeEventListener('touchmove', this.handleOnMove);
    document?.body?.removeEventListener('mouseleave', this.handleMoveOutBrowser);
  }
}
